var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "amendment-document" },
    [
      _c("section-title", {
        staticClass: "mt-4 mb-3",
        attrs: { "has-line": "", title: "Documento de Enmienda" }
      }),
      _c(
        "document-info",
        _vm._g(
          {
            attrs: {
              "add-file": !_vm.readOnly,
              "custom-add-file": false,
              document: _vm.document,
              "document-title": "Tipo de documento:",
              "file-preview": _vm.readOnly,
              "show-filename": ""
            }
          },
          _vm.$listeners
        )
      ),
      !_vm.readOnly
        ? _c(
            "div",
            [
              _c("section-title", {
                staticClass:
                  "amendment-document__section-title d-none d-md-block",
                attrs: {
                  icon: "far fa-check-circle",
                  reverse: "",
                  title: "Certifiación de Documento de Enmienda",
                  "title-class": "amendment-document__section-title__info"
                }
              }),
              _c("validation-provider", {
                attrs: { name: "certificaction", rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-checkbox-single-option", {
                            ref: "customCheckboxRef",
                            staticClass:
                              "custom-single-option amendment-document__checkbox",
                            attrs: {
                              "custom-error-msg":
                                "Favor certificar el documento de enmienda.",
                              error: errors[0],
                              "option-text": _vm.item.question,
                              title: _vm.item.questionTitle
                            },
                            model: {
                              value: _vm.certified,
                              callback: function($$v) {
                                _vm.certified = $$v
                              },
                              expression: "certified"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  731471874
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }